import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Table,
  Form,
  Select,
  Modal,
  message,
  Tooltip,
  Tag,
  Icon,
  Input,
  Radio,
  Row,
  Col,
  Switch,
  Badge,
  DatePicker,
  Upload,
  Divider
} from 'antd';
import moment from 'moment';
import {
  constructColumnFilterCheckbox,
  constructColumnFilterRadio,
  constructColumnFilterSearch,
  constructColumn,
  handleOnAggregationTableChange
} from 'utils/table/table';
import { getPlanList, resubScribeSubscription } from 'utils/apis/eInvoice';
import { getHosts } from '../../../utils/apis/host';
import { StyledCard, StyledHeader } from '../eInvoice.styles';
import { withAppContext } from 'context/AppContext';
import { CSVLink } from 'react-csv';
import { getConstants } from 'utils/apis/constants';
import { msicCodes } from 'utils/constants';

const FormItem = Form.Item;
const { Option, OptGroup } = Select;
const { RangePicker } = DatePicker;

const ResubscribeModal = props => {
  const { getFieldDecorator, getFieldValue } = props.form;
  const [loading, setLoading] = useState(false);

  const [planOptions, setPlanOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [voucherCodeOptions, setVoucherCodeOptions] = useState([]);

  const [iconPhoto, setIconPhoto] = useState([]);

  useEffect(() => {
    getConstants('countries').then(resCountries => {
      console.log('resCountries', resCountries);
      if (resCountries && resCountries.status === 200) {
        let countries = Object.keys(resCountries.data).map(k => {
          return resCountries.data[k];
        });
        if (countries.length > 0) {
          setCountryOptions(
            countries.map(u => {
              return { value: u.iso3, label: u.name };
            })
          );
        }
      } else {
        message.error('Error while retrieving countries');
      }
    });

    getConstants('statesMY').then(resStates => {
      console.log('resStates', resStates);
      if (resStates && resStates.status === 200) {
        let states = Object.keys(resStates.data).map(k => {
          return resStates.data[k];
        });
        if (states.length > 0) {
          setStateOptions(
            states.map(state => {
              return { value: state.code, label: state.label };
            })
          );
        }
      } else {
        message.error('Error while retrieving states');
      }
    });
  }, []);

  useEffect(() => {
    getPlanList().then(res => {
      console.log('getPlanList', res);
      if (res.status >= 200 && res.status < 300) {
        setPlanOptions(res.data.subscriptions.filter(p => p.name !== 'Trial Plan' && !String(p.name).includes('(Promo)')));
        setVoucherCodeOptions(res.data.vouchers);
      }
    });
  }, []);

  const handleOnFormSubmit = e => {
    e.preventDefault();

    props.form.validateFields((err, values) => {
      if (!err) {
        values.projectId = props.id;
        values.priceId =
          values.annualSubscription === true
            ? planOptions.find(p => p.name === values.plan).priceIdAnually
            : planOptions.find(p => p.name === values.plan).priceIdMonthly;

        delete values.plan;
        delete values.amount;
        delete values.annualSubscription;

        console.log('values', values);

        Modal.confirm({
          title: 'Confirm subscription?',
          content: 'Please make sure all the information is correct before submitting.',
          okText: 'Confirm',
          onOk() {
            setLoading(true);
            resubScribeSubscription(values).then(response => {
              setLoading(false);

              console.log('resubScribeSubscription', response);

              if (response.status >= 200 && response.status < 300) {
                window.location.href = response.data.redirectUrl;
                props.onCancel();
              } else {
                message.error(response.data.message || 'Failed to resubscribe');
                setLoading(false);
              }
            });

            // .catch(error => {
            //   message.error('Failed to resubscribe');
            //   setLoading(false);
            // });
          }
        });
      }
    });
  };

  const normFile = e => {
    if (Array.isArray(e)) {
      return e;
    }
    if (e && e.fileList) {
      return e.fileList;
    }
  };

  return (
    <Modal
      title="Choose a plan"
      width={window.innerWidth < 1200 ? '90%' : '60%'}
      visible={props.visible}
      maskClosable={false}
      afterClose={() => {
        props.form.resetFields();
      }}
      onCancel={() => {
        props.onCancel();
      }}
      footer={
        <div>
          <Row type="flex" justify="end">
            <Col>
              <Button
                key="back"
                onClick={() => {
                  props.onCancel();
                }}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button key="submit" onClick={handleOnFormSubmit} type="primary" loading={loading}>
                Continue to payment
              </Button>
            </Col>
          </Row>
        </div>
      }
    >
      <Form
        // hideRequiredMark
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 14 }}
      >
        <Form.Item label="Plan">
          {getFieldDecorator('plan', {
            rules: [{ required: true, message: 'Plan is required' }]
          })(
            <Select
              disabled={loading}
              onChange={value => {
                props.form.setFieldsValue({
                  amount: planOptions.find(p => p.name === value).pricePerMonth,
                  annualSubscription: false
                });
              }}
            >
              {planOptions.map(option => (
                <Option key={option.name} value={option.name}>
                  {option.name}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>

        {/* <Form.Item label="Annual Subscription">
          {getFieldDecorator(
            'annualSubscription',
            { valuePropName: 'checked' },
            {
              // rules: [{ required: true, message: 'Annual subscription is required' }]
            }
          )(
            <Switch
              disabled={loading || !getFieldValue('plan') || getFieldValue('plan') === 'Trial Plan'}
              onChange={value => {
                if (value) {
                  props.form.setFieldsValue({
                    amount: planOptions.find(p => p.name === getFieldValue('plan')).pricePerYear
                  });
                } else {
                  props.form.setFieldsValue({
                    amount: planOptions.find(p => p.name === getFieldValue('plan')).pricePerMonth
                  });
                }
              }}
            />
          )}
        </Form.Item> */}

        <Form.Item label="Amount (RM)">
          {getFieldDecorator('amount', {
            rules: [{ required: true, message: 'Amount is required' }]
          })(<Input type="number" readOnly />)}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default withAppContext(Form.create()(ResubscribeModal));
